<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Pm017c/tc-custom/9781788634885.jpg?1726755969840" alt="This image is the cover for the book For Kicks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">For Kicks
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times</i>–bestselling “master of crime fiction and equine thrills,” a horse breeder goes undercover to investigate a horse doping scheme (<i>Newsday)</i>.</b><br/>  <br/> Dick Francis, Edgar Award–winning master of mystery and suspense, takes you into the thrilling world of horse racing.<br/>  <br/> Australian horse breeder Daniel Roke had resisted the exorbitant sum of money offered by a suave Englishman to investigate a scandal involving drugged racehorses.<br/>  <br/> But after another investigator dies mysteriously, Roke agrees to fill his shoes, and learns that men who would give drugs to horses are capable of doing much worse to human beings . . .<br/>  <br/><b>Praise for Dick Francis: </b><br/>  <br/> “Dick Francis is a wonder.” —<i>The Plain Dealer</i><br/><br/> “Few things are more convincing than Dick Francis at a full gallop.” —<i>Chicago Tribune</i><br/><br/> “Few match Francis for dangerous flights of fancy and pure inventive menace.” —<i>Boston Herald</i><br/><br/> “[Francis] has the uncanny ability to turn out simply plotted yet charmingly addictive mysteries.” —<i>The </i><i>Wall Street Journal</i><br/><br/> “Francis is a genius.” —<i>Los Angeles Times</i><br/><br/> “Nobody executes the whodunit formula better.” —<i>Chicago Sun-Times</i><br/><br/> “A rare and magical talent . . . who never writes the same story twice.” —<i>The </i><i>San Diego Union-Tribune</i><br/>   
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dick Francis
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?226ccc4e